import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Funder } from 'src/app/core/models/funder';

@Component({
  selector: 'app-reports-index-list-item',
  templateUrl: './reports-index-list-item.component.html',
  styleUrls: ['./reports-index-list-item.component.scss']
})
export class ReportsIndexListItemComponent {
  @Input() url!: string;
  @Input() title!: string;

  constructor(
    private router: Router,
  ) {

  }

  navigatorTo() {
    this.router.navigateByUrl(this.url)
  }
}
